var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":'التقارير',"description":'الإيداع حسب المنتج.'}}),_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('dateFilter',{staticClass:"col-md-3"}),_c('searchInput',{staticClass:"col-md-3",attrs:{"title":"المستخدم","plaseholder":"اختر مستخدم","show":'name',"refrance":'id',"value":_vm.params.user_id,"values":this.users},model:{value:(_vm.params.user_id),callback:function ($$v) {_vm.$set(_vm.params, "user_id", $$v)},expression:"params.user_id"}}),_c('searchInput',{staticClass:"col-md-3",attrs:{"title":"المخزن","plaseholder":"اختر مخزن","show":'name',"refrance":'id',"value":_vm.params.store_id,"values":_vm.$database.stores},model:{value:(_vm.params.store_id),callback:function ($$v) {_vm.$set(_vm.params, "store_id", $$v)},expression:"params.store_id"}}),_c('searchInput',{staticClass:"col-md-3",attrs:{"title":"المنتج","plaseholder":"اختر منتج","show":'name',"refrance":'id',"value":_vm.params.product_id,"values":_vm.$database.products},model:{value:(_vm.params.product_id),callback:function ($$v) {_vm.$set(_vm.params, "product_id", $$v)},expression:"params.product_id"}}),_c('div',{staticClass:"form-group col-md-3"},[_c('label',[_vm._v(" تصنيف المنتجات ")]),_c('multiselect',{attrs:{"options":_vm.$database.sections,"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":'اختر تصنيف',"label":"name","track-by":"name","hide-selected":true},model:{value:(_vm.selectedSections),callback:function ($$v) {_vm.selectedSections=$$v},expression:"selectedSections"}})],1),_c('actionButtons',{staticClass:"col-md-3"})],1)])]),_c('div',{attrs:{"id":"reportShow"}},[_c('reportHeader',{attrs:{"title":"الإيداع حسب المنتج","details":[
            {title: 'اسم المستخدم', value : _vm.userName },
            {title: 'المخزن', value : _vm.storeName },
            {title: 'المنتج', value : _vm.productName },
            {title: 'التصنيف', value : _vm.sectionName },
          ]}}),_c('reportTable',{attrs:{"emptyTableText":'لايوجد بيانات حاليا',"emptyTableSubText":'جرب اضافة البعض واعد المحاولة',"cloumns":[
            {
              column: 'store_id',
              title: _vm.$t('storesDeposits.storeName'),
              type: 'link',
              to: 'store',
              sort: true,
              link: true,
            },

            {
              column: 'product_name',
              link: '/products',
              title: 'اسم المنتج',
              type: 'reportMainLink',
              sort: true,
            },
            {
              column: 'detail',
              title: 'النوع',
              type: 'textOrEmpty',
              sort: true,
            },
            { column: 'quantity', title: 'الكمية', type: 'text', sort: true },
            {
              column: 'average',
              title: 'المتوسط',
              type: 'text',
              sort: true,
              supData: true,
            },
            {
              column: 'price',
              title: 'الأجمالي',
              type: 'text',
              sort: true,
            },
          ],"footer":[
            { colspan: 2, value: 'المجموع' },
            { colspan: 1, value: _vm.quantity },
            {
              colspan: 1,
              value: '',
            },
            { colspan: 1, value: _vm.price },
            {
              colspan: 1,
              value: _vm.earning,
              disable: !(
                this.$user.admin ||
                this.$user.role.reports_earning_show
              ),
            },
          ]}})],1)],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_c('i',{staticClass:"fal fa-edit"}),_vm._v(" خيارات التقرير ")])])
}]

export { render, staticRenderFns }